import { render, staticRenderFns } from "./content-text.vue?vue&type=template&id=ca223e78&scoped=true"
import script from "./content-text.vue?vue&type=script&lang=js"
export * from "./content-text.vue?vue&type=script&lang=js"
import style0 from "./content-text.vue?vue&type=style&index=0&id=ca223e78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca223e78",
  null
  
)

export default component.exports